<template>
  <div>
    <status-string v-if="status === ApproveStatus.Approved" class="text-green" text="Активен" />
    <status-string v-if="status === ApproveStatus.Declined" class="text-red" text="Отклонен" />
    <status-string v-if="status === ApproveStatus.OnApproval" class="text-blue" text="На рассмотрении" />
  </div>
</template>

<script setup lang="ts">
import StatusString from '@/core/components/common/StatusString.vue';
import { ApproveStatus } from '@/graphql/generated';

defineProps<{
  status: ApproveStatus;
  size?: 'M';
}>();
</script>

<style scoped lang="scss"></style>
